// Per-table backup prefs — the shared, admin-set backup MODE tag. A table is
// either untagged (full backup), 'structure' (DDL only), 'sample' (DDL + the
// first N rows, N = the per-user `backup.sampleRows` pref, Settings → Backup),
// or 'skip' (excluded from the backup entirely). Read by the Objects panel
// (badges) and the Backup dialog (counts); set from the table right-click menu.
import { api } from './api.js';

// Returns { structureOnly, sampleData, skip } (string[]) for (connection, db).
export async function loadBackupModes(connectionId, database) {
  const r = await api.get(`/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/backup-prefs`);
  return { structureOnly: r.structureOnly || [], sampleData: r.sampleData || [], skip: r.skip || [] };
}

// Set a table's backup mode: 'structure' | 'sample' | 'skip' | 'none' (clears
// the tag). Admin only.
export async function setBackupMode(connectionId, database, table, mode) {
  return api.put(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/tables/${encodeURIComponent(table)}/backup-prefs`,
    { mode },
  );
}
